module.exports = __webpack_public_path__ + "img/business-green.1ba7bd94.svg";